import { Action } from '@ngrx/store';
import { DepartmentFood } from '@app/models/department-food';

interface DepartmentFoodCreationData {
    name: string;
    level: number;
    ParentId: number;
}

export enum DepartmentFoodActionTypes {
    Load = '[API] Load Departments Food',
    LoadSuccess = '[API] Load Departments Food Success',
    LoadFail = '[API] Load Departments Food Fail',

    LoadByConditions = '[API] Load by conditions Departments Food',
    LoadByConditionsSuccess = '[API] Load by conditions Departments Food Success',
    LoadByConditionsFail = '[API] Load by conditions Departments Food Fail',

    Create = '[API] Create Department Food',
    CreateSuccess = '[API] Create Department Food Success',
    CreateFail = '[API] Create Department Food Fail',

    Select = '[Department] Select Food',

    Search = '[Search] Search department Food',
    SearchSuccess = '[Search] Search department Food success',
    SearchFail = '[Search] Search department Food fail',
    ClearSearch = '[Search] Clear search department Food',

    Clear = '[Search] Clear department Food',

    Update = '[DepartmentFood] Update department Food',
    UpdateSuccess = '[DepartmentFood] Update department Food success',
    UpdateFail = '[DepartmentFood] Update department Food fail',

    Delete = '[DepartmentFood] Delete department Food',
    DeleteSuccess = '[DepartmentFood] Delete department Food success',
    DeleteFail = '[Delete] Delete department Food fail',

    LoadById = '[API] Load by Id Department Food',
    LoadByIdSuccess = '[API] Load by Id Department Food success',
    LoadByIdFail = '[API] Load by Id Department Food fail',

    Void = '[VOID] Void action that should not be handled',
}

export class Load implements Action {
    readonly type = DepartmentFoodActionTypes.Load;
    constructor() { }
}

export class LoadSuccess implements Action {
    readonly type = DepartmentFoodActionTypes.LoadSuccess;
    constructor(public departmentsFood: DepartmentFood[]) { }
}

export class LoadFail implements Action {
    readonly type = DepartmentFoodActionTypes.LoadFail;
    constructor(public error: any) { }
}

export class LoadByConditions implements Action {
    readonly type = DepartmentFoodActionTypes.LoadByConditions;
    constructor(public FollowId: number, public dataConditions?: any) { }
}

export class LoadByConditionsSuccess implements Action {
    readonly type = DepartmentFoodActionTypes.LoadByConditionsSuccess;
    constructor(public departmentsFood: DepartmentFood[]) { }
}

export class LoadByConditionsFail implements Action {
    readonly type = DepartmentFoodActionTypes.LoadByConditionsFail;
    constructor(public error: any) { }
}

export class Create implements Action {
    readonly type = DepartmentFoodActionTypes.Create;
    constructor(public data: DepartmentFoodCreationData) { }
}

export class CreateSuccess implements Action {
    readonly type = DepartmentFoodActionTypes.CreateSuccess;
    constructor(public departmentsFood: DepartmentFood) { }
}

export class CreateFail implements Action {
    readonly type = DepartmentFoodActionTypes.CreateFail;
    constructor(public error: any) { }
}

export class Select implements Action {
    readonly type = DepartmentFoodActionTypes.Select;
    constructor(public id: number) { }
}

export class Search implements Action {
    readonly type = DepartmentFoodActionTypes.Search;
    constructor(public data: any, public FollowId: any) { }
}

export class SearchSuccess implements Action {
    readonly type = DepartmentFoodActionTypes.SearchSuccess;
    constructor(public DepartmentIds: number[]) { }
}

export class SearchFail implements Action {
    readonly type = DepartmentFoodActionTypes.SearchFail;
    constructor(public error: any) { }
}

export class ClearSearch implements Action {
    readonly type = DepartmentFoodActionTypes.ClearSearch;
    constructor() { }
}

export class Clear implements Action {
    readonly type = DepartmentFoodActionTypes.Clear;
    constructor() { }
}

export class Update implements Action {
    readonly type = DepartmentFoodActionTypes.Update;
    constructor(public id: number, public department: any) { }
}
export class UpdateFail implements Action {
    readonly type = DepartmentFoodActionTypes.UpdateFail;
    constructor(public error: any) { }
}

export class UpdateSuccess implements Action {
    readonly type = DepartmentFoodActionTypes.UpdateSuccess;
    constructor(public id: number, public department: any) { }
}

export class Delete implements Action {
    readonly type = DepartmentFoodActionTypes.Delete;
    constructor(public id: number) { }
}
export class DeleteFail implements Action {
    readonly type = DepartmentFoodActionTypes.DeleteFail;
    constructor(public error: any) { }
}

export class DeleteSuccess implements Action {
    readonly type = DepartmentFoodActionTypes.DeleteSuccess;
    constructor(public DepartmentId: any) { }
}

export class Void implements Action {
    readonly type = DepartmentFoodActionTypes.Void;
    constructor() { }
}


export class LoadById implements Action {
    readonly type = DepartmentFoodActionTypes.LoadById;
    constructor(public FollowId: number, public dataFilter?: any) { }
}

export class LoadByIdSuccess implements Action {
    readonly type = DepartmentFoodActionTypes.LoadByIdSuccess;
    constructor(public CategoryId: any, public data: any) { }
}

export class LoadByIdFail implements Action {
    readonly type = DepartmentFoodActionTypes.LoadByIdFail;
    constructor(public error: any) { }
}

export type DepartmentFoodActionsUnion =
    | Load
    | LoadSuccess
    | LoadFail
    | LoadByConditions
    | LoadByConditionsSuccess
    | LoadByConditionsFail
    | Create
    | CreateSuccess
    | CreateFail
    | Select
    | Search
    | SearchSuccess
    | SearchFail
    | ClearSearch
    | Clear
    | Update
    | UpdateSuccess
    | UpdateFail
    | Delete
    | DeleteSuccess
    | DeleteFail
    | LoadById
    | LoadByIdSuccess
    | LoadByIdFail
    | Void;
